/* eslint-disable @typescript-eslint/no-unused-vars */
import { settingsCommonStyles } from '../creation-common-styles/settings-common-style';
import { doubleListA11yHackerStyles } from '../creation-common-styles/double-list-a11y-hacker-styles';

export const adgroupCreationStyles = ({ palette = {}, iconFontFamily = 'MsAds MDL2 Assets' }) => ({
  '& .adgroup-create-page': {
    padding: '25px 32px 0 32px',

    '& .alert.alert-danger': {
      paddingLeft: '8px',
    },
    '& h1': {
      margin: 0,
      fontSize: 20,
      color: '#323130',
    },
    '& h3': {
      fontSize: 14,
      color: '#323130',
      margin: '14px 0',
      fontWeight: 'normal',
    },

    '& hr': {
      display: 'none',
    },

    '& .type-bold': {
      fontSize: 18,
      paddingTop: 8,
      borderTop: `1px solid ${palette.neutralSecondary}`,
      margin: '30px 0 0 0',
      clear: 'both',
    },

    '& .container-fluid': {
      padding: 1,
      margin: 0,
      border: 'none',
      '& .form-group': {
        margin: 0,

        '& #LanguageSelectorDescription': {
          paddingBottom: 7,
        },
      },

      '& .language': {
        margin: '5px 0',
      },
    },

    '& .adgroup-settings .bidding-strategy__container .form-group': {
      '& #BidStrategySetting_BidStrategy_Label': {
        padding: [5, 0],
      },

      '& .col-sm-6 > .form-control-static': {
        paddingBottom: 8,
        minHeight: 1,
      },
    },

    '& .toggle-campaign-settings-switch': {
      paddingRight: '8px !important',
      marginTop: 3,
      display: 'inline-block',
      float: 'left',
    },

    '& .type-normal': {
      fontWeight: 400,
    },

    '& .audience-advanced-target-settings': {
      paddingTop: 10,
    },

    '& .ad-section': {
      minHeight: 150,

      '& .alert': {
        marginTop: 15,
      },

      '& .adEditor-listitem': {
        marginRight: 70,
      },

      '& .ads-creative .row.col-sm-3': {
        left: 900,
      },
    },

    '& .location-targets-section': {
      '& .control-label': {
        marginTop: 33,
      },

      '& .form-horizontal': {
        '& > div:nth-child(2) .control-label': {
          marginTop: 10,
        },

        '& .location-target-physical-intent': {
          '& .control-label': {
            marginTop: '33px !important',
          },
        },
      },

      '& .form-group .col-sm-2': {
        display: 'block',
      },
    },

    '& .location-target-done': {
      margin: '0 12px 0 15px',
    },

    '& .advanced-settings-section': {
      marginTop: 30,
      paddingBottom: 0,
      borderTop: `1px solid ${palette.neutralSecondary}`,
      paddingTop: 8,

      '& .date-container>.form-control-static': {
        minHeight: 230,
      },
    },

    '& .advanced-settings-title': {
      display: 'none',
    },

    '& .add-keywords-root': {

      marginTop: 30,

      '& .col-sm-4': {
        padding: 0,

        '& #Keyword_Bmm_Warning_Div': {
          padding: '8px 32px 8px 8px',
        },

        '& #Keyword_Bmm_Block_Div': {
          padding: '8px 32px 8px 8px',
        },
      },

      '& .keyword-planner-root': {
        marginTop: 10,
      },
    },

    '& .save-bar': {
      borderTop: '1px solid #EDEBE9',
      paddingTop: 16,
      margin: '35px 0 0 -32px',
      padding: '16px 32px',

      '& .btn-save': {
        marginRight: 12,
      },
    },

    '& .bid-section': {
      position: 'relative',

      '& .alert': {
        margin: '8px 16px -26px 16px',
      },

      '& .search-bid__container': {
        '& .bidSuggestion .col-sm-10': {
          paddingLeft: 0,
        },
        '& .btn-apply-bid': {
          marginLeft: 8,
          width: '38px',
          height: '24px',
          marginTop: 0,
        },
        '& .iconba.iconba-Lightbulb': {
          color: '#0078D4',
          fontSize: '14px',
          fontFamily: iconFontFamily,
          position: 'absolute',
          top: '18px',
        },

        '& .alert-info-inline': {
          marginLeft: '20px',
        },

        'div[data-bind="visible: showEstimateButton"]': {
          padding: 0,
        },

        '& span.status-container': {
          display: 'inline-block',
          width: '14px',
          position: 'absolute',
          height: '100%',

          '& .iconba.iconba-Warning': {
            color: '#FF9900',
            fontSize: '14px',
            fontFamily: iconFontFamily,
            position: 'absolute',
            left: '2px',
            top: '9px',
          },
        },
      },

      '& .bidWarning': {
        marginLeft: 0,
        marginTop: 6,
        '& .alert-info-inline': {
          marginLeft: '0!important',
        },
      },
    },

    '& .auto-targets-section': {
      '& .type-bold': {
        borderTop: 0,
      },
      '& .panel.authoring-container': {
        boxShadow: 'none',
        '& .category-container .grid-table .clickable': {
          cursor: 'pointer',
        },
      },
    },

    '& .adgroup-settings #AdGroupCreate_KoErrors': {
      marginLeft: 15,
    },
  },

  '& .mixed-mode-adgroup-create': {
    '& ul.alert': {
      marginTop: 10,
    },
    '& .dynamic-adgroup-creation-section-container>h3, & .standard-adgroup-creation-section-container>h3': {
      height: 30,
      marginBottom: 0,
      '& a': {
        paddingLeft: 0,
        fontSize: 18,
        '&:hover': {
          textDecoration: 'none',
          backgroundColor: '#f3f2f1',
        },
      },
      '& .expandedImage, & .expanderImage': {
        marginRight: 11,
      },
    },
    '& #standardAdGroupSection, & #dynamicAdGroupSection': {
      marginLeft: 24,
    },
    '& .filter-clear': {
      clear: 'both',
    },
  },

  '& .mixed-mode-ad-group-creation-container': {
    '& .dynamic-ad-group-create-view-container .row-fluid .ad-group-list-container': {
      marginTop: 0,
    },
    '&>ul.alert': {
      margin: '0 32px',
    },
    '& .mixed-mode-ad-group-creation-title, & .ad-group-type-section, & .adgroup-creation-dsa-settings-view-container': {
      padding: '0 32px 0 32px',
      '& .control-label': {
        lineHeight: 1.5,
      },
    },
    '& .save-bar': {
      borderTop: '1px solid #EDEBE9',
      paddingTop: 16,
      margin: '35px 0 0 0',
      padding: '16px 32px',

      '& .btn-save': {
        marginRight: 12,
      },
    },
  },
  '& .adgroup-settings': settingsCommonStyles({ palette }),
  ...doubleListA11yHackerStyles(),
});


// this style is out of the feature scope, so use as the global pattern
export const globalAdgroupCreationStyles = ({ palette = {} }) => ({
  '.change-adgroup-type-view': {
    paddingBottom: 10,
    '& .change-adgroup-type-title': {
      fontWeight: 'bold',
      display: 'block',
      paddingBottom: 10,
    },
  },
});
